// extracted by mini-css-extract-plugin
export default {"link-button":"link-button_link-button__5XfX4"};